import { render, staticRenderFns } from "./KanbanListHeader.vue?vue&type=template&id=2eebd6e6&"
import script from "./KanbanListHeader.vue?vue&type=script&lang=js&"
export * from "./KanbanListHeader.vue?vue&type=script&lang=js&"
import style0 from "./KanbanListHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports